import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-ng-logo',
  standalone: true,
  imports: [CommonModule],
  template: `
        <img  [style]='logo.style'
        [src]="(logo.imgUrl.base64Extension ? 'data:image/'+logo.imgUrl.base64Extension+';base64,' : '')+logo.imgUrl.url" [height]="(logo.height || 35)" [width]="(logo.width || 35)"/>
  `,
  styles: ``
})
export class LogoComponent {
    @Input() logo: Img = {
        width: 60,
        height: 60,
        title: "R/A Platform",
        imgUrl:{ 
            base64Extension: "svg+xml",
            url: "PHN2ZyB3aWR0aD0iMzA1IiBoZWlnaHQ9IjI1NyIgdmlld0JveD0iMCAwIDMwNSAyNTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMTUuOTQzIDE3OS4wOUMyMTUuOTQzIDE2Ni4xMjggMjI2LjQ2NSAxNTUuNjExIDIzOS40MiAxNTUuNjExQzI1Mi4zODIgMTU1LjYxMSAyNjIuODkzIDE2Ni4xMjggMjYyLjg5MyAxNzkuMDlDMjYyLjg5MyAxOTIuMDUyIDI1Mi4zODIgMjAyLjU2MSAyMzkuNDIgMjAyLjU2MUMyMjYuNDY1IDIwMi41NjEgMjE1Ljk0MyAxOTIuMDUyIDIxNS45NDMgMTc5LjA5WiIgZmlsbD0iIzg2QkMyNCIvPgo8cGF0aCBkPSJNMTU2LjI4MyAxMTYuOTEyQzE1Ni4yODMgMTAyLjA0MSAxNTMuNDEgOTEuMDA4MyAxNDcuNjYyIDgzLjgyMDdDMTQxLjkwOCA3Ni42NCAxMzMuMTkxIDczLjA1MjkgMTIxLjQ3MyA3My4wNTI5SDEwOS4wMDdWMTYzLjk5MUgxMTguNTQ1QzEzMS41NjEgMTYzLjk5MSAxNDEuMDk5IDE2MC4xMzIgMTQ3LjE3MyAxNTIuMzg4QzE1My4yMzkgMTQ0LjY1NyAxNTYuMjgzIDEzMi44MjkgMTU2LjI4MyAxMTYuOTEyWk0yMDAuNzM5IDExNS4zNjNDMjAwLjczOSAxNDIuNDU2IDE5My40NTcgMTYzLjMzMiAxNzguODkxIDE3Ny45ODVDMTY0LjMyNiAxOTIuNjQ2IDE0My44NTEgMTk5Ljk3NiAxMTcuNDU4IDE5OS45NzZINjYuMTczNlYzNy42MzE4SDEyMS4wMzhDMTQ2LjQ4NiAzNy42MzE4IDE2Ni4xMzMgNDQuMjk2MiAxNzkuOTc4IDU3LjYxODNDMTkzLjgxNyA3MC45NDcxIDIwMC43MzkgOTAuMTg2NCAyMDAuNzM5IDExNS4zNjNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"}
      };
}

export type Img = {
    height: number;
    width: number;
    title: string;
    imgUrl: ImgUrl;
    style?: string;
  }

  export interface ImgUrl{
    base64Extension?: 'png' | 'svg' | 'svg+xml' | 'simple';
    url: string;
  }


